import { getV2UsersMeOffHoursSchedulesSelector } from "./getV2UsersMeOffHoursSchedulesSelector";
import { RootState } from "../../../store";
import { OffHoursSchedule2 } from "../../../../services/cloudchipr.api";

export const offHoursDataSelector = (
  state: RootState,
): OffHoursSchedule2[] | undefined => {
  return getV2UsersMeOffHoursSchedulesSelector(state)?.data;
};
